import React__default from 'react';
import { Button } from '@amzn/storm-ui';
import { u as useIntl } from '../../LocalModules/storm-ui-intl/dist/esm/3rdPartyModules/react-intl/lib/src/components/useIntl-voJ4yxcS-DU7lWLPF.js';

const LoadingIndicator = () => {
  const {
    formatMessage
  } = useIntl();
  return /*#__PURE__*/React__default.createElement(Button, {
    loading: true
  }, formatMessage({
    id: 'loading-label'
  }));
};

export { LoadingIndicator as L };
//# sourceMappingURL=LoadingIndicator-CiFQpbxF.js.map
